/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-16 18:16:45
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-12 14:08:31
 * @FilePath: /unifyxp-v2-store-portal/src/components/FilterGroup/SelectionFilter.tsx
 */
import React from 'react';
import css from './Query.less';
import DropDown from '@/src/components/Antd/DropDown/DropDown';
import { Icon } from '@/src/tools/icon';
import { Menu } from 'antd';
const SelectionFilter = (props) => {
  const { item, index, overlayClick } = props;
  const overlay = (item, index) => (
    <Menu className={css.queryOverlay}>
      {(item || []).map((list) => (
        <Menu.Item
          className={css.overlaylist}
          key={`${list.key}-${index}`}
          onClick={() => overlayClick([list])}>
          {list.name}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <DropDown
      className={css.filterDrop}
      key={index}
      maxWidth={200}
      maxHeight={300}
      overlay={overlay(item.data, index)}
      trigger={['click']}>
      <a className={css.BulkEdit} onClick={(e) => e.preventDefault()}>
        {item.name} <Icon type='icondown' className={css.icon} />
      </a>
    </DropDown>
  );
};
export default SelectionFilter;
